<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <div class="subheading">
        {{ $t("view.commons.records") }}
      </div>
      <v-spacer />
      <v-btn icon @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-fade-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <filters ref="filters" @filter="filter" @report="report" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              class="reportevisitas dataTable"
              sort-by="fechaalta"
              :sort-desc="true"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options">
              <template #top>
                <v-text-field
                  v-model.trim="search"
                  dense
                  clearable
                  hide-details
                  :label="$t('view.commons.search')"
                  append-icon="mdi-magnify"
                  @keydown.enter="refreshSearch"
                  @click:append="refreshSearch"
                  @click:clear="clearSearch" />
              </template>
              <template #item.fechaalta="{ item }">
                {{ item.fecha }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-fade-transition>
  </v-card>
</template>
<script>
import Filters from "@/views/reportes/reportevisitas/Filters"; /** *******************************/
import ReporteVisitasAPI from "@/services/reportes/reportevisitas"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

export default {
  components: { Filters }
  , data() {
    return {
      options: {}
      , filtros: {}
      , search: ""
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.reportes.reportevisitas.tabla.clave"), align: "center", sortable: true, class: "tablaHeader clave", cellClass: "clave", value: "clave" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.fecha"), align: "center", sortable: true, class: "tablaHeader fecha", cellClass: "fecha", value: "fechaalta" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.rep"), align: "left", sortable: true, class: "tablaHeader rep", cellClass: "rep", value: "rep" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.estatus"), align: "center", sortable: true, class: "tablaHeader estatus", cellClass: "estatus", value: "estatus" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.provincia"), align: "left", sortable: true, class: "tablaHeader provincia", cellClass: "provincia", value: "provincia" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.localidad"), align: "left", sortable: true, class: "tablaHeader localidad", cellClass: "localidad", value: "localidad" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.cp"), align: "center", sortable: true, class: "tablaHeader cp", cellClass: "cp", value: "cp" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.tipoform"), align: "center", sortable: true, class: "tablaHeader tipoform", cellClass: "tipoform", value: "tipoform" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.tipo"), align: "center", sortable: true, class: "tablaHeader tipo", cellClass: "tipo", value: "tipo" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.campana"), align: "left", sortable: true, class: "tablaHeader campana", cellClass: "campana", value: "campana" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.oob"), align: "center", sortable: true, class: "tablaHeader oob", cellClass: "oob", value: "oob" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.estatuscorte"), align: "center", sortable: true, class: "tablaHeader ecorte", cellClass: "ecorte", value: "estatuscorte" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.status"), align: "left", sortable: true, class: "tablaHeader status", cellClass: "status", value: "status" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.substatus"), align: "left", sortable: true, class: "tablaHeader substatus", cellClass: "substatus", value: "substatus" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.base"), align: "left", sortable: true, class: "tablaHeader base", cellClass: "base", value: "base" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.exclusion"), align: "center", sortable: true, class: "tablaHeader exclusion", cellClass: "exclusion", value: "exclusion" }
              , { text: this.$t("view.reportes.reportevisitas.tabla.vendor"), align: "left", sortable: true, class: "tablaHeader vendor", cellClass: "vendor", value: "vendor" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const tipoUsuario = this.$store.getters.getUserData.tipoUsuario;
      if (tipoUsuario == "VENDOR") {
        this.filtros.vendor = this.$store.getters.getUserData.idVendor;
      }

      if (!this.filtros.estatus) {
        this.filtros.estatus = "PENDIENTE,ASIGNADO,VISITA_INICIADA,VISITA_EN_PROCESO,VISITA_FINALIZADA,ERROR,VALIDACION_CORRECTA,ENVIADO_SFT,CANCELADO,VENCIDO";
      }

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;
      this.$refs.filters.loading(true);

      const serverSideDataT = this.prepareData();
      const response = await ReporteVisitasAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
      this.$refs.filters.loading(false);
    }
    , refreshData() {
      this.load();
    }
    , refreshSearch() {
      this.options.page = 1;
      this.load();
    }
    , clearSearch() {
      this.search = "";
      this.options.page = 1;
      this.load();
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.options.page = 1;
      this.filtros = fls;
      await this.load();
    }
    , async report() {
      if (this.view.elem.datatable.total <= 0) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.minregs"));
        return false;
      }

      if (this.view.elem.datatable.total > 100000) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.maxregs"));
        return false;
      }

      this.$refs.filters.loading(true);

      try {
        const serverSideDataT = this.prepareData();
        const response = await ReporteVisitasAPI.report(serverSideDataT);
        if (response && response.data.size > 0) {
          const url = globalThis.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", response.headers.filename.replaceAll("\"", "")); // or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.errrep"));
        }
      } catch (error) {
        console.error(error);
      }

      this.$refs.filters.loading(false);
    }
  }
};
</script>

<style>
.reportevisitas .clave {
  width: 100px !important;
  min-width: 100px !important;
}

.reportevisitas .fecha {
  width: 190px !important;
  min-width: 190px !important;
}

.reportevisitas .rep {
  width: 250px !important;
  min-width: 250px !important;
}

.reportevisitas .estatus {
  width: 200px !important;
  min-width: 200px !important;
}

.reportevisitas .provincia {
  width: 300px !important;
  min-width: 300px !important;
}

.reportevisitas .localidad {
  width: 300px !important;
  min-width: 300px !important;
}

.reportevisitas .cp {
  width: 80px !important;
  min-width: 80px !important;
}

.reportevisitas .tipoform {
  width: 120px !important;
  min-width: 120px !important;
}

.reportevisitas .tipo {
  width: 120px !important;
  min-width: 120px !important;
}

.reportevisitas .campana {
  width: 200px !important;
  min-width: 200px !important;
}

.reportevisitas .oob {
  width: 80px !important;
  min-width: 80px !important;
}

.reportevisitas .ecorte {
  width: 200px !important;
  min-width: 200px !important;
}

.reportevisitas .status {
  width: 200px !important;
  min-width: 200px !important;
}

.reportevisitas .substatus {
  width: 300px !important;
  min-width: 300px !important;
}

.reportevisitas .base {
  width: 600px !important;
  min-width: 600px !important;
}

.reportevisitas .exclusion {
  width: 150px !important;
  min-width: 150px !important;
}

.reportevisitas .vendor {
  width: 150px !important;
  min-width: 150px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/reportes/reportevisitas/DataTable.vue